<template>
  <div class="row">
    <!--  名企一对一列表  -->
    <div class="flex xs12">
      <va-card title="名企一对一列表">
        <div class="row align--center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button
                disabled
                flat
                color="gray"
              >课程标签：</va-button>
              <va-button
                flat
                :color="tagId !==null ? 'gray' : 'info'"
                v-on:click="handleTagIdChange(null)"
              >全部标签</va-button>
              <va-button
                flat
                :color="tagId === val.id ? 'info' : 'gray'"
                :key="val.id" v-for="val in courseTags"
                v-on:click="handleTagIdChange(val.id)"
              >{{ val.name }}</va-button>
            </va-button-group>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="courses"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listAllCourse"
          api-mode
        >
          <template slot="imgUrl" slot-scope="props">
            <img :src="props.rowData.imgUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
              v-bind:style="{margin: '1rem auto', width: '50%'}"
              oninput="if(value<0)value=1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>

import allCourseApi from '../../../api/allCourse'
import { computeServiceStatus, formatTime } from '@/utils/common'
import { APPLIED_SERVICE_TYPE, SERVICE_AUDIT_TYPES, SERVICE_STATUS_TYPES, TAG_TYPE } from '@/utils/constants'
import tagApi from '../../../api/tag'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      courses: [],
      name: '',
      loading: true,
      pageNumber: 1,
      totalCount: 0,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
      status: 1,
      auditStatus: SERVICE_AUDIT_TYPES.APPROVED.CODE,
      courseTags: [],
      tagId: null,
      statusOptions: SERVICE_STATUS_TYPES,
      appliedServiceType: APPLIED_SERVICE_TYPE,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'name',
          title: '课程名称',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:imgUrl',
          title: '封面图',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'serviceType',
          title: '课程类型',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },

        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'updateTime',
          title: '更新时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listCourseTag()
    this.listAllCourse()
  },
  methods: {
    listAllCourse (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: this.status,
        auditStatus: this.auditStatus,
        tagId: this.tagId,
        name: this.name,
      }
      allCourseApi.listAllCourse(params).then(response => {
        this.courses = response.courses
        this.courses.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },
    listCourseTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    handleTagIdChange (tagId) {
      this.tagId = tagId
      this.listAllCourse()
    },
    updateSortNum: function (params) {
      const data = {
        id: params.id,
        sortNum: params.sortNum,
        type: params.type,
      }
      allCourseApi.updateSortNum(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listAllCourse()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computedColor: function (status) {
      return this.status === status ? 'info' : 'gray'
    },
    computeStatus: function (status) {
      return computeServiceStatus(status)
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 2%;
}
</style>
